export default "__VITE_ASSET__c_CDAMOi__"